import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
// import TablesEfficiencyActions from "../../../components/User/TablesEfficiencyComponents/TablesEfficiencyActions";
// import TablesEfficiencyTable from "../../../components/User/TablesEfficiencyComponents/TablesEfficiencyTable";
import ProductProfitabilityActions from "../../../components/User/ProductProfitabilityComponents/ProductProfitabilityActions";
import ProductProfitabilityTables from "../../../components/User/ProductProfitabilityComponents/ProductProfitabilityTables";

const { getRestaurants } = appActions;

const ProductProfitability = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Надценка на продукти" />
      <ProductProfitabilityActions />
      <ProductProfitabilityTables />
    </div>
  );
};

export default ProductProfitability;
